// =======================================
// DATA TYPES
// =======================================

/**
 * Reset password flow state. The recovery email link signs the user into a
 * temporary session; 'verifying' waits for that session to be detected.
 */
export interface ResetPasswordState {
  step: 'verifying' | 'form' | 'complete' | 'invalid';
  password: string;
  confirmPassword: string;
  loading: boolean;
  error: string | null;
}

// =======================================
// CONSTANTS AND OPTIONS
// =======================================

export const ERROR_MESSAGES = {
  INVALID_LINK: 'This password reset link is invalid or has expired. Please request a new one.',
  UPDATE_FAILED: 'Failed to update your password. Please try again.'
} as const;

export const SUCCESS_MESSAGES = {
  PASSWORD_UPDATED: 'Your password has been updated!',
  REDIRECT_MESSAGE: 'You will be redirected shortly.'
} as const;

/** How long to wait for the recovery session before declaring the link invalid */
export const SESSION_WAIT_MS = 2500;

export const DEFAULT_STATE: ResetPasswordState = {
  step: 'verifying',
  password: '',
  confirmPassword: '',
  loading: false,
  error: null
} as const;
